import type { MessageKey } from '@/i18n'
import type { V1TaskId } from '../../model/delivery'
import type { V1IconName } from '../sprite'

/** The crop's picture on the task list (as on the crop screen). */
export const CROP_ICON: Partial<Record<string, V1IconName>> = {
  moong: 'moong',
  groundnut: 'groundnut',
}

/** The V1 task list's icons and names (the task list and Home's "Left: …"). */
export const TASK_ICON: Record<V1TaskId, V1IconName> = {
  forms: 'book',
  moisture: 'drop',
  bags: 'tag',
  seal: 'seal',
  bank: 'passbook',
}

export const TASK_NAME: Record<V1TaskId, MessageKey> = {
  forms: 'gate.v1.task.forms',
  moisture: 'gate.v1.task.moisture',
  bags: 'gate.v1.task.bags',
  seal: 'gate.v1.task.seal',
  bank: 'gate.v1.task.bank',
}

/** Home's "Left: …" names, kept short. */
export const TASK_SHORT: Record<V1TaskId, MessageKey> = {
  forms: 'gate.v1.task.short.forms',
  moisture: 'gate.v1.task.short.moisture',
  bags: 'gate.v1.task.short.bags',
  seal: 'gate.v1.task.short.seal',
  bank: 'gate.v1.task.short.bank',
}
